import { Button, Icon, DefaultInputV2 as Input } from 'common/components'

interface Props {
  email: string
  index: number
  translate: (key: string) => string
  onRemoveButtonClick: (key: number) => void
  onChange: (fn: (value: string, index: number) => string) => void
}

const SecondaryEmailInput = ({
  email,
  translate,
  onRemoveButtonClick: removeSecondaryEmail,
  onChange: setSecondaryEmail,
  index,
}: Props) => (
  <div key={`email-${index}`}>
    <label>{translate('save-prospect.secondary-email-label').replace('[]', (index + 1).toString())} </label>
    <div className={'flex_space_between mb-8'}>
      <Input
        name={`secondaryEmails.${index}`}
        className="mr-8"
        onChange={(e) => setSecondaryEmail((x, i) => (i === index ? e.target.value : x))}
      />
      <Button type="default" onClick={() => removeSecondaryEmail(index)} className="flex__space_between_centered">
        <Icon type="far fa-minus" fontAwesome />
      </Button>
    </div>
  </div>
)

export default SecondaryEmailInput
